import { Box, Checkbox, Flex, SimpleGrid } from '@chakra-ui/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { createContext, Dispatch, useContext } from 'react';
// eslint-disable-next-line import/no-cycle,import/named
import { PartitionKeysContext } from './ConnectChart';

const DynamicComparison: React.FC = () => {
  return (
    <SimpleGrid mt={8} columns={3} gridColumnGap={12} gridRowGap={8}>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={[
            'dp',
            'delen',
            'dierickx-leys',
            'quintet',
            'vanlanschot',
            'axa',
            'bnp',
            'kbc',
            'ing-pure-equity',
            'belfius-global-allocation-equity',
          ]}
          label="Private banking"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox partitionKey="dp" label="Degroof Petercam Global Strategy L High" />
          <PartitionKeyCheckBox partitionKey="delen" label="Capfi Delen World Equities" />
          <PartitionKeyCheckBox partitionKey="dierickx-leys" label="Diericx Leys Fund" />
          <PartitionKeyCheckBox partitionKey="quintet" label="Quintet Private Bank – Strategic Dynamic" />
          <PartitionKeyCheckBox partitionKey="vanlanschot" label="Van Lanschot High Growth Portfolio" />
          <PartitionKeyCheckBox partitionKey="axa" label="AXA Delegio Dynamic" />
          <PartitionKeyCheckBox partitionKey="bnp" label="BNPPF Private Sustainable Dynamic" />
          <PartitionKeyCheckBox partitionKey="kbc" label="KBC Private Banking Comfort Dynamic" />
          <PartitionKeyCheckBox partitionKey="ing-pure-equity" label="ING Pure Equity" />
          <PartitionKeyCheckBox
            partitionKey="belfius-global-allocation-equity"
            label="Belfius Portfolio - Global Allocation Equity"
          />
        </Flex>
      </Box>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={['msci-energy', 'msci-financials', 'msci-health-care', 'msci-industrials', 'nasdaq']}
          label="Sectoren"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox partitionKey="msci-energy" label="MSCI World Energy" />
          <PartitionKeyCheckBox partitionKey="msci-financials" label="MSCI ACWI Financials" />
          <PartitionKeyCheckBox partitionKey="msci-health-care" label="MSCI ACWI Health Care" />
          <PartitionKeyCheckBox partitionKey="msci-industrials" label="MSCI ACWI Industrials" />
          <PartitionKeyCheckBox partitionKey="nasdaq" label="Nasdaq 100" />
        </Flex>
      </Box>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={[
            'msci-ex-us',
            'msci-china',
            'msci-india',
            'msci-usa',
            'msci-europe',
            'amundi-s&p-500',
            'index',
            'stoxx',
            'eurostoxx',
          ]}
          label="Geografisch"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox partitionKey="msci-ex-us" label="MSCI ACWI ex-US" />
          <PartitionKeyCheckBox partitionKey="msci-china" label="MSCI China ETF" />
          <PartitionKeyCheckBox partitionKey="msci-india" label="MSCI India" />
          <PartitionKeyCheckBox partitionKey="msci-usa" label="MSCI USA" />
          <PartitionKeyCheckBox partitionKey="msci-europe" label="MSCI Europe" />
          <PartitionKeyCheckBox partitionKey="amundi-s&p-500" label="Amundi S&P 500" />
          <PartitionKeyCheckBox partitionKey="index" label="S&P 500 Equal Weight" />
          <PartitionKeyCheckBox partitionKey="stoxx" label="Eurostoxx 600" />
          <PartitionKeyCheckBox partitionKey="eurostoxx" label="Eurostoxx 600 Equal Weight" />
        </Flex>
      </Box>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={[
            'conviction',
            'echiquier',
            'lfde-world',
            'lfde-value',
            'tocqueville-value',
            'lfde-growth-europe',
            'lfde-mid-cap-europe',
            'lfde-next-leaders',
            'lfde-luxury',
          ]}
          label="Portfolio"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox partitionKey="conviction" label="Connect Conviction" />
          <PartitionKeyCheckBox partitionKey="echiquier" label="LFDE QME A" />
          <PartitionKeyCheckBox partitionKey="lfde-world" label="LFDE World Equity" />
          <PartitionKeyCheckBox partitionKey="lfde-value" label="LFDE Value" />
          <PartitionKeyCheckBox partitionKey="tocqueville-value" label="Tocqueville Value" />
          <PartitionKeyCheckBox partitionKey="lfde-growth-europe" label="LFDE Growth Europe" />
          <PartitionKeyCheckBox partitionKey="lfde-mid-cap-europe" label="LFDE Mid Cap Europe" />
          <PartitionKeyCheckBox partitionKey="lfde-next-leaders" label="LFDE Next Leaders" />
          <PartitionKeyCheckBox partitionKey="lfde-luxury" label="LFDE Luxury" />
        </Flex>
      </Box>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={['msci-quality', 'us-sector', 'global-aerospace-defence']}
          label="Portfolio"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox partitionKey="msci-quality" label="MSCI USA Quality Factor ETF" />
          <PartitionKeyCheckBox partitionKey="us-sector" label="US Sector Value" />
          <PartitionKeyCheckBox
            partitionKey="global-aerospace-defence"
            label="iShares Global Aerospace & Defence ETF"
          />
        </Flex>
      </Box>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={[
            // 'baltic-dry',
            'usd',
            // 'fidelity-us-value',
            // 'ab-american-growth',
            // 'berkshire-hathaway',
            'jreu',
            'amundi-us-pioneer',
          ]}
          label="Diversen"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          {/* <PartitionKeyCheckBox partitionKey="baltic-dry" label="Baltic Dry" /> */}
          <PartitionKeyCheckBox partitionKey="usd" label="USD/EUR" />
          {/* <PartitionKeyCheckBox partitionKey="fidelity-us-value" label="Fidelity US Value" /> */}
          {/* <PartitionKeyCheckBox partitionKey="ab-american-growth" label="AB I American Growth" /> */}
          {/* <PartitionKeyCheckBox partitionKey="berkshire-hathaway" label="Berkshire Hathaway" /> */}
          <PartitionKeyCheckBox partitionKey="jreu" label="JPM US Equity index (ETF)" />
          <PartitionKeyCheckBox partitionKey="amundi-us-pioneer" label="Amundi US Pioneer Equity" />
        </Flex>
      </Box>
    </SimpleGrid>
  );
};

export default DynamicComparison;

interface PartitionCheckBoxProps {
  partitionKey: string;
  label: string;
}

export const PartitionKeyCheckBox: React.FC<PartitionCheckBoxProps> = ({ partitionKey, label }) => {
  const { partitionKeys, setPartitionKeys } = useContext(PartitionKeysContext);
  const handleOnChange = (checked: boolean) => {
    if (checked) setPartitionKeys([...partitionKeys, partitionKey]);
    else {
      const newPartitionKeys = [...partitionKeys.filter((x) => x !== partitionKey)];
      setPartitionKeys(newPartitionKeys.length > 0 ? newPartitionKeys : undefined);
    }
  };
  return (
    <Checkbox
      minW="max-content"
      isChecked={partitionKeys.includes(partitionKey)}
      onChange={(e) => handleOnChange(e.target.checked)}
    >
      {label}
    </Checkbox>
  );
};

interface ParentPartitionKeyCheckBoxProps {
  keys: string[];
  label: string;
}

export const ParentPartitionKeyCheckBox: React.FC<ParentPartitionKeyCheckBoxProps> = ({ keys, label }) => {
  const { partitionKeys, setPartitionKeys } = useContext(PartitionKeysContext);
  const allChecked = keys.every((x) => partitionKeys.includes(x));
  const isIndeterminate = keys.some((x) => partitionKeys.includes(x)) && !allChecked;

  const handleOnChange = (checked: boolean) => {
    if (checked) {
      keys.forEach((x) => {
        if (!partitionKeys.includes(x)) partitionKeys.push(x);
      });
      setPartitionKeys([...partitionKeys]);
    } else {
      const newPartitionKeys = [...partitionKeys.filter((x) => !keys.includes(x))];
      setPartitionKeys(newPartitionKeys.length > 0 ? newPartitionKeys : undefined);
    }
  };
  return (
    <Checkbox
      isChecked={allChecked}
      isIndeterminate={isIndeterminate}
      onChange={(e) => handleOnChange(e.target.checked)}
    >
      {label}
    </Checkbox>
  );
};
